import { CheckCircleOutlined, WarningOutlined, DisconnectOutlined } from "@ant-design/icons"
import { ErrorOutlined } from "@mui/icons-material"

const statusMap = {
    0: "ok",
    1: "warning",
    2: "error"
}

export const mapStatus = (status) => statusMap[status] ?? "offline"

export const getStatusAggregate = (cards) =>
    cards.reduce((acc, { Status }) => {
        return Status > acc ? Status : acc
    }, 0)

export const getStatusColor = (status) => {
    switch (status.toUpperCase()) {
        case "OK":
            return "green"
        case "WARNING":
            return "orange"
        case "ERROR":
            return "red"
        default:
            return "gray"
    }
}

export const getStatusIcon = (status) => {
    switch (status.toUpperCase()) {
        case "OK":
            return <CheckCircleOutlined style={{ color: getStatusColor(status) }} />
        case "WARNING":
            return <WarningOutlined style={{ color: getStatusColor(status) }} />
        case "ERROR":
            return <ErrorOutlined style={{ color: getStatusColor(status) }} />
        default:
            return <DisconnectOutlined style={{ color: getStatusColor(status) }} />
    }
}

export const POSITIONS = ["SERVICE_MODE", "INTERMEDIATE", "FILL", "FLUSH", "BRINE_UP", "BRINE", "RINSE", "BACKWASH"]
export const mapPosition = (p) => `ID_${POSITIONS[p]}`
